import { MeliService } from '@/common/api.service'
import {
  FETCH_SALES
} from './actions.type'

import {
  FETCH_START,
  FETCH_START_INFINITE,
  FETCH_END_MELI
} from './mutations.type'

const state = {
  sales: [],
  totalSalesPages: 1,
  totalSales: 0,
  currentSalesPage: 0,
  isLoadingMeli: false,
  isLoading: false,
  updating: true
}
export const actions = {
  [FETCH_SALES] ({commit}, searchCriteria) {
    if (searchCriteria.filters.params.page === 1) {
      commit(FETCH_START)
    } else {
      commit(FETCH_START_INFINITE)
    }
    return MeliService.query(searchCriteria.filters)
      .then(({ data }) => {
        commit(FETCH_END_MELI, data)
        return data
      }).catch(({ error }) => {
        commit(FETCH_END_MELI, {data: [], pagination: {limit: 0, page: 1, total: 0}})
        return error
      })
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [FETCH_START] (state) {
    state.isLoadingMeli = true
  },
  [FETCH_START_INFINITE] (state) {
    state.updating = true
  },
  [FETCH_END_MELI] (state, sales) {
    state.sales = sales.data
    state.totalSalesPages = Math.round(sales.pagination.total / 50)
    state.totalSales = sales.pagination.total
    state.currentSalesPage = sales.pagination.page
    state.isLoadingMeli = false
    state.isLoading = false
    state.updating = false
  }
}

const getters = {
  sales(state) {
    return state.sales
  },
  totalSalesPages(state) {
    return state.totalSalesPages
  },
  totalSales(state) {
    return state.totalSales
  },
  currentSalesPage(state) {
    return state.currentSalesPage
  },
  updating(state) {
    return state.updating
  },
  isLoadingMeli(state) {
    return state.isLoadingMeli
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
